"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HIGHLIGHT_LABELS = exports.SyndicationInvestmentPriority = exports.SyndicationInvestmentRanges = exports.SyndicationInvestmentTypes = exports.ProcessStatus = void 0;
var ProcessStatus;
(function (ProcessStatus) {
    ProcessStatus["ReadyForSyndication"] = "ready_for_syndication";
    ProcessStatus["NotReadyForSyndication"] = "not_ready_for_syndication";
})(ProcessStatus = exports.ProcessStatus || (exports.ProcessStatus = {}));
var SyndicationInvestmentTypes;
(function (SyndicationInvestmentTypes) {
    SyndicationInvestmentTypes["Angel"] = "angel";
    SyndicationInvestmentTypes["GrowthEquity"] = "growth_equity";
    SyndicationInvestmentTypes["LeveragedBuyOut"] = "leveraged_buy_out";
    SyndicationInvestmentTypes["MezzDebt"] = "mezz_debt";
    SyndicationInvestmentTypes["PreIpo"] = "pre_IPO";
    SyndicationInvestmentTypes["Seed"] = "seed";
    SyndicationInvestmentTypes["SeniorBankDebt"] = "senior_bank_debt";
    SyndicationInvestmentTypes["SeriesA"] = "series_a";
    SyndicationInvestmentTypes["SeriesBPlus"] = "series_b_plus";
    SyndicationInvestmentTypes["SpecialSituations"] = "special_situations";
    SyndicationInvestmentTypes["VentureDebt"] = "venture_debt";
    SyndicationInvestmentTypes["SmallCapPublic"] = "small_cap_public";
    SyndicationInvestmentTypes["ReceivablesFinance"] = "receivables_finance";
})(SyndicationInvestmentTypes = exports.SyndicationInvestmentTypes || (exports.SyndicationInvestmentTypes = {}));
var SyndicationInvestmentRanges;
(function (SyndicationInvestmentRanges) {
    SyndicationInvestmentRanges["LessThan1M"] = "less_than_1_m";
    SyndicationInvestmentRanges["Between1And5M"] = "between_1_and_5_m";
    SyndicationInvestmentRanges["Between5And10M"] = "between_5_and_10_m";
    SyndicationInvestmentRanges["Between10And25M"] = "between_10_and_25_m";
    SyndicationInvestmentRanges["Between25And50M"] = "between_25_and_50_m";
    SyndicationInvestmentRanges["Between50And100M"] = "between_50_and_100_m";
    SyndicationInvestmentRanges["MoreThan100M"] = "more_than_100_m";
})(SyndicationInvestmentRanges = exports.SyndicationInvestmentRanges || (exports.SyndicationInvestmentRanges = {}));
var SyndicationInvestmentPriority;
(function (SyndicationInvestmentPriority) {
    SyndicationInvestmentPriority[SyndicationInvestmentPriority["p1"] = 1] = "p1";
    SyndicationInvestmentPriority[SyndicationInvestmentPriority["p2"] = 2] = "p2";
    SyndicationInvestmentPriority[SyndicationInvestmentPriority["p3"] = 3] = "p3";
    SyndicationInvestmentPriority[SyndicationInvestmentPriority["p4"] = 4] = "p4";
})(SyndicationInvestmentPriority = exports.SyndicationInvestmentPriority || (exports.SyndicationInvestmentPriority = {}));
exports.HIGHLIGHT_LABELS = {
    ltmRevenue: 'LTM Revenue',
    lastMonthEBITDA: 'Last Month EBITDA',
    yoyRevenueGrowth: 'YoY Revenue Growth',
    ltmGrossMargin: 'LTM Gross Margin',
    runRateRevenue: 'Run Rate Revenue',
    qoqRevenueGrowth: 'QoQ Revenue Growth',
    totalEquityRaised: 'Total Equity Raised',
};
//# sourceMappingURL=enums.js.map